<template>
  <div class='lt-scene_dining-table'>
    <Transition name='slideY-down' v-show='food === 1'>
      <div class='lt-scene_dining-table_table lt-scene_dining-table_table--1' />
    </Transition>

    <Transition name='slideY-down' v-show='food === 2'>
      <div class='lt-scene_dining-table_table lt-scene_dining-table_table--2' />
    </Transition>

    <Transition name='slideY-down' v-show='food === 3'>
      <div class='lt-scene_dining-table_table lt-scene_dining-table_table--3' />
    </Transition>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields([
      'scene.status.food',
    ]),
  },
};
</script>
